import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please enter first name' },
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please enter last name' },
      ]
      },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
       },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a telephone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    ClientName: {
      validations: []
    },
    theme: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' }
      ]
    },
    StartTime: {
      validations: []
    }, 
    EndTime: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    reference: {
      validations: []
    },
    notes: {
      validations: []
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
       }
       ]
      },
      {
        fields: [
          {
           type: 'text',
           size: 'Medium',
           label: 'Last Name:*',
           mapping: 'lastName'
         }
       ]
      },
       {
          fields: [
            {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
          },
         ]
        },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Phone:*',
           mapping: 'telnumber'
        }
        ]
      },
        {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company Name (If applicable):',
            mapping: 'ClientName'
          }
        ]
      },
        {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'Nature of Event:',
              mapping: 'theme'
            }
          ]
        },
        {
          fields: [
            {
              type: 'date-picker',
              size: 'Medium',
              label: 'Event Date:',
              mapping: 'eventDate'
         }
          ]
        },
        {
          fields: [
            {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Event Start Time:',
                options: [
                  { label: '7:30 AM', value: '07:30:00' },
                  { label: '8:00 AM', value: '08:00:00' },
                  { label: '8:30 AM', value: '08:30:00' },
                  { label: '9:00 AM', value: '09:00:00' },
                  { label: '9:30 AM', value: '09:30:00' },
                  { label: '10:00 AM', value: '10:00:00' },
                  { label: '10:30 AM', value: '10:30:00' },
                  { label: '11:00 AM', value: '11:00:00' },
                  { label: '11:30 AM', value: '11:30:00' },
                  { label: '12:00 PM', value: '12:00:00' },
                  { label: '12:30 PM', value: '12:30:00' },
                  { label: '1:00 PM', value: '13:00:00' },
                  { label: '1:30 PM', value: '13:30:00' },
                  { label: '2:00 PM', value: '14:00:00' },
                  { label: '2:30 PM', value: '14:30:00' },
                  { label: '3:00 PM', value: '15:00:00' },
                  { label: '3:30 PM', value: '15:30:00' },
                  { label: '4:00 PM', value: '16:00:00' },
                  { label: '4:30 PM', value: '16:30:00' },
                  { label: '5:00 PM', value: '17:00:00' },
                  { label: '5:30 PM', value: '17:30:00' },
                  { label: '6:00 PM', value: '18:00:00' },
                  { label: '6:30 PM', value: '18:30:00' },
                  { label: '7:00 PM', value: '19:00:00' },
                  { label: '7:30 PM', value: '19:30:00' },
                  { label: '8:00 PM', value: '20:00:00' },
                  { label: '8:30 PM', value: '20:30:00' },
                  { label: '9:00 PM', value: '21:00:00' },
                  { label: '9:30 PM', value: '21:30:00' },
                  { label: '10:00 PM', value: '22:00:00' },
                  { label: '10:30 PM', value: '22:30:00' },
                  { label: '11:00 PM', value: '23:00:00' },
                  { label: '11:30 PM', value: '23:30:00' },
                  { label: '12:00 AM (next day)', value: '00:00:00' },
                  { label: '12:30 AM (next day)', value: '00:30:00' },
                  { label: '1:00 AM (next day)', value: '01:00:00' },
                  { label: '1:30 AM (next day)', value: '01:30:00' },
                  { label: '2:00 AM (next day)', value: '02:00:00' },
                  { label: '2:30 AM (next day)', value: '02:30:00' }
                ],
                mapping: 'StartTime'
              }
          ]
        },
        {
          fields: [
            {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Event End Time:',
                options: [
                  { label: '7:30 AM', value: '07:30:00' },
                  { label: '8:00 AM', value: '08:00:00' },
                  { label: '8:30 AM', value: '08:30:00' },
                  { label: '9:00 AM', value: '09:00:00' },
                  { label: '9:30 AM', value: '09:30:00' },
                  { label: '10:00 AM', value: '10:00:00' },
                  { label: '10:30 AM', value: '10:30:00' },
                  { label: '11:00 AM', value: '11:00:00' },
                  { label: '11:30 AM', value: '11:30:00' },
                  { label: '12:00 PM', value: '12:00:00' },
                  { label: '12:30 PM', value: '12:30:00' },
                  { label: '1:00 PM', value: '13:00:00' },
                  { label: '1:30 PM', value: '13:30:00' },
                  { label: '2:00 PM', value: '14:00:00' },
                  { label: '2:30 PM', value: '14:30:00' },
                  { label: '3:00 PM', value: '15:00:00' },
                  { label: '3:30 PM', value: '15:30:00' },
                  { label: '4:00 PM', value: '16:00:00' },
                  { label: '4:30 PM', value: '16:30:00' },
                  { label: '5:00 PM', value: '17:00:00' },
                  { label: '5:30 PM', value: '17:30:00' },
                  { label: '6:00 PM', value: '18:00:00' },
                  { label: '6:30 PM', value: '18:30:00' },
                  { label: '7:00 PM', value: '19:00:00' },
                  { label: '7:30 PM', value: '19:30:00' },
                  { label: '8:00 PM', value: '20:00:00' },
                  { label: '8:30 PM', value: '20:30:00' },
                  { label: '9:00 PM', value: '21:00:00' },
                  { label: '9:30 PM', value: '21:30:00' },
                  { label: '10:00 PM', value: '22:00:00' },
                  { label: '10:30 PM', value: '22:30:00' },
                  { label: '11:00 PM', value: '23:00:00' },
                  { label: '11:30 PM', value: '23:30:00' },
                  { label: '12:00 AM (next day)', value: '00:00:00' },
                  { label: '12:30 AM (next day)', value: '00:30:00' },
                  { label: '1:00 AM (next day)', value: '01:00:00' },
                  { label: '1:30 AM (next day)', value: '01:30:00' },
                  { label: '2:00 AM (next day)', value: '02:00:00' },
                  { label: '2:30 AM (next day)', value: '02:30:00' }
                ],
                mapping: 'EndTime'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Estimated Number of Guests:',
                mapping: 'plannedguestcount'
              }
            ]
          },
            {
              fields: [
                {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'How Did You Hear About Us?:',
                options: [
                  { label: 'EventUp', value: 'EventUp'},
                  { label: 'Instagram', value: 'Instagram'},
                  { label: 'Facebook', value: 'Facebook'},
                  { label: 'Search engine', value: 'Search engine'},
                  { label: 'Email', value: 'Email'},
                  { label: 'Other', value: 'Other'},
                ],
                mapping: 'reference'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text-area',
                size: 'XLarge',
                label: 'Any Additional Details About Your Event?:',
                mapping: 'notes'
              }
            ]
          },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Live Nation - Midway Music Hall Contact Form',
    formId: '2203',
    clientKey: 'AA8C70E4-59C4-4FEB-97FB-DA16EF669FD3',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you for your inquiry. We will reach out shortly. Thank you!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
